import{CdsButton as t}from"./button.element.js";class e extends t{constructor(){super();this.size="icon"}}export{e as CdsIconButton};
//# sourceMappingURL=icon-button.element.js.map
